import actionTypes from '../actionTypes';

const initialState = {
  callList: [],
  team: {}
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.ONLINE_CALL_LIST:
      newState.callList = action.payload.data;
      return newState;
    case actionTypes.ONLINE_TEAM:
      newState.team = action.payload.data;
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/online.reducer.js